module.exports = __webpack_public_path__ + "static/media/si.894b0d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/si.png
// module id = 1978
// module chunks = 0